import type { Ari } from '@atlassian/jira-platform-ari/src/index.tsx';
import type { preloadedDevSummaryDataQuery$data as preloadedDevSummaryDataQueryData } from '@atlassian/jira-relay/src/__generated__/preloadedDevSummaryDataQuery.graphql';
import type { mainIssueAggQuery$data } from '@atlassian/jira-relay/src/__generated__/mainIssueAggQuery.graphql.ts';
import { preloadedDevSummaryData } from './dev-summary-request/preloadedDevSummaryData.tsx';

type FetchDevSummaryDataType = (
	issueAri: Ari,
) => Promise<preloadedDevSummaryDataQueryData | undefined>;

type PreloadedDataRequests = {
	currentIssueAri?: Ari;
	fetchDevSummaryPromise: Promise<preloadedDevSummaryDataQueryData | undefined> | null;
	getFetchDevSummaryPromise: FetchDevSummaryDataType;
	clearAllPromises: () => void;
	fetchAllAGGDependantRequests: (issueAri: Ari) => void;
	handleIssueAriChange: (issueAri: Ari) => void;
};

export const preloadedDataRequests: PreloadedDataRequests = {
	currentIssueAri: undefined,
	fetchDevSummaryPromise: null,

	clearAllPromises() {
		this.fetchDevSummaryPromise = null;
	},

	fetchAllAGGDependantRequests(issueAri: Ari) {
		this.handleIssueAriChange(issueAri);
		// fetch all the data we need
		this.getFetchDevSummaryPromise(issueAri);
	},

	handleIssueAriChange(issueAri: Ari) {
		if (this.currentIssueAri !== issueAri) {
			this.clearAllPromises();
			this.currentIssueAri = issueAri;
		}
	},

	getFetchDevSummaryPromise(issueAri: Ari) {
		this.handleIssueAriChange(issueAri);

		if (this.fetchDevSummaryPromise === null) {
			this.fetchDevSummaryPromise = preloadedDevSummaryData(issueAri);
		}

		return this.fetchDevSummaryPromise;
	},
};

export const preloadAllAGGDependantRequests = (
	issueAggData: mainIssueAggQuery$data | null | undefined,
) => {
	// @ts-expect-error id is not on the type but it is in the data
	const issueAri = issueAggData?.jira?.issueByKey?.id;

	if (issueAri) {
		preloadedDataRequests.fetchAllAGGDependantRequests(issueAri);
	}
};

export const fetchDevSummaryData: FetchDevSummaryDataType = (issueAri) => {
	return preloadedDataRequests.getFetchDevSummaryPromise(issueAri);
};
